module.exports = "<p>\n  services works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dev-man/Kgwetlwo-app/src/app/pages/services/services.component.html
// module id = ../../../../../src/app/pages/services/services.component.html
// module chunks = main